import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { Link, useNavigate, useParams } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import {
  useAcceptInviteSendOTPMutation,
  useAcceptInviteVerifyOTPMutation,
  useLazyGetInvestorByTokenQuery,
} from "store/api/investors/investors.api"
import OTPInput from "react-otp-input"
import logo from "../../assets/images/logo-light1.svg"
import eye from "../../assets/images/icons/eye.svg"
import hide from "../../assets/images/icons/hide.svg"
import { setLoginUserData } from "store/slices/userSlice"
import { useDispatch } from "react-redux"
import { userTypes } from "helpers/utils"

const Verify = () => {
  //meta title
  document.title = "Verify Account | Prachay"

  const { token } = useParams()
  const [accountType, setAccountType] = useState("INVESTOR")
  const [otpView, setOtpView] = useState(false)
  const [verify, { isLoading: onVerifying }] =
    useAcceptInviteVerifyOTPMutation()
  const dispatch = useDispatch()

  const [send, { isLoading }] = useAcceptInviteSendOTPMutation()
  const [getInvestor, { isFetching: isGetting }] =
    useLazyGetInvestorByTokenQuery()
  const [investor, setInvestor] = useState()
  const [show, setShow] = useState(false)
  const counterTime = 60
  const [counter, setCounter] = useState(0)

  const history = useNavigate()

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      otp: "",
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (otpView) {
        handleVerify(values)
      } else {
        handleSendOTP(values)
      }
    },
  })

  useEffect(() => {
    if (otpView && counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [counter])

  useEffect(() => {
    if (token) {
      const onGetInvestor = async () => {
        try {
          const { data } = await getInvestor({ token }).unwrap()
          setInvestor(data)
          validation.setFieldValue("email", data.account.email)
          validation.setFieldValue("token", token)
          setAccountType(data.type)
          if (data.account.status !== "LINK_SENT") {
            history("/login")
            toast.error("You have alreay verfied your profile.", {
              id: "alreadyActiveInvestor",
            })
          }
        } catch (error) {
          if (error.status === 404) {
            history("/login")
            toast.error(
              "We have not found any account, Please contact support team.",
              {
                id: "alreadyActiveInvestor",
              }
            )
          }
        }
      }
      onGetInvestor()
    }
  }, [token])

  const handleSendOTP = async (params) => {
    const body = {
      accountType,
      token,
      email: params.email,
    }

    try {
      const { message } = await send(body).unwrap()
      setOtpView(true)
      setCounter(counterTime)
      toast.success(message, { id: "verifySuccess" })
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const handleVerify = async (params) => {
    try {
      params["accountType"] = accountType
      const { message, data } = await verify(params).unwrap()
      dispatch(
        setLoginUserData({
          userType: userTypes[accountType],
          user: data.user,
          permissions: data.user.permissions,
          auth: true,
          jwt: data.tokens.access.token,
        })
      )
      history("/dashboard")
      if (message) toast.success(message, { id: "verifySuccess" })
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const handleResendOtp = async () => {
    handleSendOTP({ ...validation.values })
  }

  return (
    <div className="account-pages">
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="p-2">
                  <img src={logo} alt="" height="50" />
                </Link>
                <div className="login-text">
                  <h4>Verify Account !</h4>
                  <p>Please verify your account.</p>
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {/* {error ? <Alert color="danger">{error}</Alert> : null} */}
                      {!otpView ? (
                        <div className="mb-2">
                          <Label className="form-label">Email Address</Label>
                          <Input
                            name="email"
                            disabled
                            className="form-control"
                            placeholder="Enter Email Address"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                      ) : (
                        <>
                          <div>
                            <Label className="form-label">Enter OTP</Label>
                            <div
                              className={`${
                                validation.errors.otp && "is-invalid"
                              }`}
                            >
                              <OTPInput
                                onChange={(val) => {
                                  validation.setFieldValue("otp", val)
                                }}
                                shouldAutoFocus
                                inputType={"number"}
                                inputStyle={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "10px",
                                  border: "1px solid #ddd",
                                }}
                                containerStyle={{
                                  display: "flex",
                                  gap: "15px",
                                }}
                                value={validation.values.otp || ""}
                                numInputs={6}
                                renderInput={(props) => <input {...props} />}
                              />
                            </div>
                            {validation.errors.otp ? (
                              <FormFeedback type="invalid">
                                {validation.errors.otp}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div
                            className="text-start mt-2"
                            style={{
                              color: "#a9a9a9",
                            }}
                          >
                            {counter > 0 && (
                              <p>
                                {`Didn't receive the OTP? Resend OTP in ${counter} sec`}
                              </p>
                            )}
                            {counter <= 0 && (
                              <p
                                style={{
                                  color: "#035ca1",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleResendOtp()}
                                // cursor={"pointer"}
                                // color={Colors.text.black}
                              >
                                {onVerifying ? (
                                  <Spinners
                                    color="dark"
                                    className="align-items-center justify-content-start"
                                  />
                                ) : (
                                  "Resend OTP"
                                )}
                              </p>
                            )}
                          </div>
                          <div className="mb-2">
                            <Label className="col-form-label">
                              Password <span className="error">*</span>
                            </Label>
                            <div className="input-wrapper">
                              <Input
                                type={show ? "text" : "password"}
                                name="password"
                                className="form-control"
                                placeholder="Enter password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={
                                  validation.errors.password ? true : false
                                }
                              />

                              <div onClick={() => setShow(!show)}>
                                {show ? (
                                  <img src={hide} alt="" />
                                ) : (
                                  <img src={eye} alt="" />
                                )}
                              </div>
                            </div>
                            {validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.password}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-2">
                            <Label className="col-form-label">
                              Confirm Password <span className="error">*</span>
                            </Label>
                            <div className="input-wrapper">
                              <Input
                                type={show ? "text" : "password"}
                                name="confirm_password"
                                className="form-control"
                                placeholder="Enter confirm Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.confirm_password || ""}
                                invalid={
                                  validation.errors.confirm_password
                                    ? true
                                    : false
                                }
                              />
                              <div onClick={() => setShow(!show)}>
                                {show ? (
                                  <img src={hide} alt="" />
                                ) : (
                                  <img src={eye} alt="" />
                                )}
                              </div>
                              {validation.errors.confirm_password ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.confirm_password}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </div>
                        </>
                      )}

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isLoading || onVerifying || isGetting}
                        >
                          {isLoading || onVerifying || isGetting ? (
                            <Spinners />
                          ) : !otpView ? (
                            "Verify Account"
                          ) : (
                            "Verify OTP"
                          )}
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(Verify)
